import { Component, OnInit, ViewChild, ChangeDetectorRef, AfterViewInit, ViewEncapsulation } from '@angular/core';
import { BaseAPIService } from '@app/Services/api.base.service';
import { AuthenticationService } from '@app/core/authentication/authentication.service';
import { MapService } from '@app/map/map.service';
import { ICoolersDetails } from '../Models/ICoolersDetails';
import { label } from '../constants/labels';
import { TabView } from 'primeng/tabview';
import { ActivatedRoute } from '@angular/router';
import { ElementRef } from '@angular/core';
import { CalendarService } from '../Services/calendar.service';
import { Table } from 'primeng/table';
import { IGridCols } from '../Models/IGridCols';
import { TelemetryService } from '../Services/telemetry.service';


@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class DashboardComponent implements OnInit, AfterViewInit {
  @ViewChild(('filtr')) filtr: ElementRef;
  recordStatus?: any;
  activeCoolersCount: number;
  inactiveCoolersCount: number;
  tabDeviceStatus: number = 1;
  coolersData: ICoolersDetails[];
  cols: Array<IGridCols>;
  labels: any;
  noData: boolean = false;
  isPagination: boolean = true;
  showfilter: boolean = false;
  filterCriteria: string = null;
  isLoading: boolean = false;
  public rect1logo: string = null;
  public rect2logo: string = null;
  public rect3logo: string = null;
  public rect1key: string = null;
  public rect1val: number = 0;
  public rect2key: string = null;
  public rect2val: number = 0;
  public rect3key: string = null;
  public rect3val: Date = null;
  public selectedCoolerName: string;
  public status: boolean;
  public rindex: number;
  selectedTabIndex: number = 0;
  setPointValues: { min: number, max: number, val: number } = { min: -10, max: 30, val: 10 }
  targetSearch: string;
  @ViewChild('tabView') tabView!: TabView;
  @ViewChild('dt') dt!: Table;
  clonedData: ICoolersDetails[];
  LastConnDateFilter: any;
  

  constructor(private readonly baseService: BaseAPIService,
    private readonly auth: AuthenticationService, private readonly route: ActivatedRoute, private readonly cdr: ChangeDetectorRef,
    private readonly mapService: MapService, public calendarService: CalendarService, private readonly telemetryService: TelemetryService) { }

  ngAfterViewInit() {
    this.route.queryParams.subscribe(params => {
      this.selectedTabIndex = this.getTabIndex(params['tab']);
      this.tabDeviceStatus = this.getTabIndex(params['tab']);
      this.cdr.detectChanges();
    });
  }

  getTabIndex(tabName: string): number {
    if (!tabName) {
      return 0;
    }

    const selectedIndex = this.tabView.tabs.findIndex(
      x => x.header.toLowerCase() === tabName.toLowerCase()
    );
    if (selectedIndex > -1) {
      return selectedIndex;
    }
    return 0;
  }
  onDeviceStatusTab(event) {
    this.tabDeviceStatus = event.index;
  }
  onChange(event) {
    this.selectedTabIndex = event.index;
  }
  ngOnInit() {

    this.isLoading = true;
    this.status = false;
    this.selectedCoolerName = '';
    this.labels = label;
    this.cols = [
      { field: 'alarm_Severity', header: '', width: '3%', display: 'auto', showInMobileView: false },
      { header: '#', width: '5%', display: 'auto', showInMobileView: false },
      { field: 'name', header: this.labels.tableHeaderDevice, width: '13%', display: 'auto', showInMobileView: true },
      { field: 'dongleUId', header: this.labels.tableHeaderDevice, width: '15%', display: 'none', showInMobileView: false },
      {
        field: 'lastConnectedOn', header: this.labels.tableHeaderLastConnect, width: '21%', display: 'auto', showInMobileView: true
      },
      { field: 'alarms_Count', header: this.labels.tableHeaderAlarm, width: '14%', display: 'auto', showInMobileView: true }, //TBD
      { field: 'locationCountry', header: this.labels.tableHeaderCountry, width: '14%', display: 'auto', showInMobileView: true },
      { field: 'groups', header: this.labels.tableHeaderGroups, width: '14%', display: 'auto', showInMobileView: true }, //TBD
      { field: 'deviceType', header: this.labels.deviceType, width: '12%', display: 'auto', showInMobileView: true },
      { field: 'deviceStatus', header: this.labels.tableHeaderDeviceStatus, width: '15%', display: 'auto', showInMobileView: true },
      { field: 'isWireless', header: '', display: 'none', showInMobileView: false },
      { field: 'id', header: '', display: 'none', showInMobileView: false },
      { field: 'mask', display: 'none', showInMobileView: false },
      { field: 'poli', display: 'none', showInMobileView: false },
      { field: 'firmwareVersion', display: 'none', showInMobileView: false },

    ];

    this.GetDeviceData();

    if (this.targetSearch !== null) {
      setTimeout(() => {
        if (this.filtr !== undefined) {
          this.filtr.nativeElement.dispatchEvent(new Event('input'));
        }
      }, 0);
    }
  }

  public GetDeviceData() {
    const apiUrl = '/DeviceDashboard/DeviceDetailForDashboard';
    this.baseService.GetWithHeaders(apiUrl, {}).subscribe((result: ICoolersDetails[]) => {
      if (result && result.length > 0) {
        this.coolersData = result;
        if (this.coolersData.length < 10) {
          this.isPagination = false;
        }
        this.coolersData.forEach((value) => {
          value.latitude = value.currentLatitude === null ? value.registrationLatitude : value.currentLatitude;
          value.longitude = value.currentLongitude === null ? value.registrationLongitude : value.currentLongitude;
        });
        this.activeCoolersCount = this.coolersData.filter(c => c.isActive === 1).length;
        this.inactiveCoolersCount = this.coolersData.filter(c => c.isActive === 0).length;
        try {
          this.mapService.addCoolersMarker(this.coolersData);
        } catch (exception) { }
        this.clonedData = this.coolersData.slice(0);
      }
      else {
        this.noData = true;
        this.isPagination = false;
      }
      this.isLoading = false;
    },
      error => {
        console.log(error);
      });
  }

  public GetCoolerLocation(latitude: number, longitude: number, name: string, coolerDet: any, rowIndex: number) {
    this.mapService.locate(latitude, longitude, coolerDet);
    this.selectedCoolerName = name;
    this.RowSelected(rowIndex);
  }

  public ToggleFilter(table: Table) {
    this.showfilter = !this.showfilter;
    this.recordStatus = 'all'
    if (!this.showfilter) {
      table.reset();
      this.LastConnDateFilter = null;
      this.recordStatus='all'
      this.coolersData = this.clonedData.slice(0);
    }
  }

  public ClickCommand(field: string, dongleUId: string, tag: string, last_connected_on: string, cooler_name: string, controllerTypeName: string, isWireless: boolean, id: number, mask: string, poli: string, firmwareVersion: string, controllerTypeId: number) {
    if (tag === "") {
      tag = null;
    }
    switch (field) {
      case "name":
        this.telemetryService.setData(tag, last_connected_on, controllerTypeName, dongleUId, cooler_name, isWireless, id, mask, poli, firmwareVersion, controllerTypeId);
        this.auth.navigateToPage('telemetry');
        break;
      case "alarm_count":
        this.auth.navigateToPage(`alarms/${cooler_name}`);
        break;
      default:
        return;

    }
  }

  public RowSelected(index: number) {
    this.rindex = index;
  }
  public recordStatusChange(event: Event) {
    this.dt.filter(this.recordStatus, 'deviceStatus', 'contains')
  }
}
